import { render, staticRenderFns } from "./ResearchGroup.html?vue&type=template&id=667bfcb4&scoped=true&external"
import script from "./ResearchGroup.vue?vue&type=script&lang=js"
export * from "./ResearchGroup.vue?vue&type=script&lang=js"
import style0 from "./ResearchGroup.scss?vue&type=style&index=0&id=667bfcb4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bfcb4",
  null
  
)

export default component.exports